import { useSelector } from 'react-redux'
import { isFetchingSelector } from '../../reducers/uiReducer'
import { AppRootState } from '../../store/types'
import LoadingOverlay from '../common/LoadingOverlay'

export default function LoadingOverlayPage() {
  const isFetching = useSelector((state: AppRootState) =>
    isFetchingSelector(state.ui),
  )
  return isFetching ? <LoadingOverlay /> : null
}
